import redirectWhenUnauthenticated from "@/service/redirect-when-unauthenticated";
import { Route } from "vue-router";

/**
 * Folders
 */
export default [
  {
    path: "/folders",
    component: () =>
      import(/* webpackChuckName: "common" */ "@/views/layout/Overview.vue"),
    beforeEnter: redirectWhenUnauthenticated("login", "unauthorized", [
      "hd_reprocessing"
    ]),
    props: {
      title: "folders.title"
    },
    children: [
      {
        path: "overview/:folderId?",
        name: "folders-overview",
        props: (route: Route) => {
          const folderId = parseInt(route.params.folderId);
          return {
            folderId: isNaN(folderId) ? null : folderId
          };
        },
        component: () =>
          import(
            /* webpackChunkName: "folders" */ "@/views/folders/Folders.vue"
          )
      },
      {
        path: "messages",
        name: "messages",
        component: () =>
          import(/* webpackChuckName: "common" */ "@/views/common/Messages.vue")
      }
    ]
  }
];
